module.exports = __webpack_public_path__ + "img/full-arc-reads-logo.c99f9102.png";